import { Box } from "@chakra-ui/react";
import React from "react";

export const ProgressBar = ({ height, progress, progressColor, bgColor, borderRadius }) => {
	return (
		<Box width={"100%"} height={height} backgroundColor={bgColor} borderRadius={`${borderRadius}px`}>
			<Box
				display={"flex"}
				flex={1}
				width={`${progress}%`}
				height={height}
				borderRadius={`${borderRadius}px 0px 0px ${borderRadius}px`}
				backgroundColor={progressColor}
			/>
		</Box>
	);
};
